import * as React from 'react';
import { IFormField } from '../../../../interfaces/interfaces';
import * as uniqid from 'uniqid';

class TextBox extends React.Component<IFormField> {
  constructor(props: IFormField) {
    super(props);
  }

  public render() {
    const { disabled, values, fieldName, type, onChange, value, label, errorMessage, description, isRequired, placeholder, onBlur, maxLength } = this.props;
    const inputId = uniqid('input' + fieldName);
    const isDisabled = 'function' === typeof disabled ? disabled(fieldName, value, values) : disabled;

    return (
      <div key={fieldName} className={'form__item' + (errorMessage ? ' hasError' : '')}>

        <div className="input-wrap">
          <label htmlFor={inputId} className="label">
            {label}
          </label>

          <input
            disabled={isDisabled}
            id={inputId}
            className={'input'}
            type={type || 'text'}
            name={fieldName}
            onChange={onChange}
            value={value || ''}
            placeholder={placeholder}
            required={isRequired}
            autoComplete="off"
            onBlur={onBlur}
            maxLength={'number' === typeof maxLength ? maxLength : undefined}
          />

          <div className="input-border">
            <span className="input-border__part" />
          </div>
        </div>

        {errorMessage && (
          <p className={'form__error'}>{errorMessage}</p>
        )}

        {description && !errorMessage && (
          <p className={'form__error'}>
            {typeof description === 'function'
              ? description(values, value)
              : description}
          </p>
        )}
      </div >
    );
  }
}

export default TextBox;



// WEBPACK FOOTER //
// ./src/components/FormGenerator/Form/components/TextBox.tsx